<template>
  <div class="videocontent">
    <!-- 分享所带图片 -->
    <img
      style="width: 0px; height: 0px; position: absolute; z-index: -1"
      src="../../assets/images/dongguologo.jpg"
    />
    <h1>{{ this.DataList[0] ? this.DataList[0].Extend2 : "" }}</h1>
    <video
      :src="this.DataList[0] ? this.DataList[0].InfoUrl : ''"
      preload="true"
      :poster="this.DataList[0] ? this.DataList[0].Extend10 : ''"
      webkit-playsinline="true"
      x5-video-player-type="h5"
      x5-video-orientation="portraint"
      autoplay
      controls
    />
  </div>
</template>

<script type="text/ecmascript-6">
import Vue from "vue";
import { Notify } from "vant";
export default {
  name: "videocontent",
  metaInfo() {
    return {
      title: `${
        this.DataList[0] ? this.DataList[0].Extend1 : ""
      }-韩国东国大学中文网`,
      meta: [
        {
          name: "keywords",
          content: `${this.DataList[0] ? this.DataList[0].Extend1 : ""}`,
        },
        {
          name: "description",
          content: `韩国东国大学${
            this.DataList[0] ? this.DataList[0].Extend1 : ""
          }宣传视频`,
        },
      ],
    };
  },
  data() {
    return {
      DataList: "",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.getData();
      },
    },
  },
  activated() {
    this.$emit("handleTKD", "东国概况");
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post("/trip/TokenPass/GetPublishMenuContent", {
          // WebsiteMenuId: Number(this.$route.params.id),
          // WebsiteContentId: Number(this.$route.params.WebsiteContentId),
          WebsiteMenuId: Number(this.$route.params.WebsiteContentId),
          WebsiteContentId:  Number(this.$route.params.id),
          index: 1,
          size: 1,
        })
        .then((res) => {
          if (res.data.Code == 200) {
            console.log(1);
            this.DataList = res.data.Data.list;
            console.log(this.DataList);
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.videocontent {
  width: 750px;
  margin: 0 auto;
  padding: 0 40px;
  margin-top: 134px;
  padding-top: 60px;
  margin-bottom: 60px;
  h1 {
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 40px;
    white-space: normal;
    word-break: break-all;
  }
  video {
    display: block;
    margin: 0 auto;
    max-width: 100%;
    // width: 100%;
    // height: 100%;
    // 使图片展示不压缩
    object-fit: cover;
    outline: none;
    position: relative;
  }
}
</style>
